export enum InsuranceType {
  Health = 101,
  KidnapRansom = 131,
  Life = 141,
  CriticalIllness = 151,
  Travel = 171,
  Telemedicine = 181,
  Student = 191,
  ICAonlyCasespecific = 998,
  ICAonlyGeneralAgreement_notproductspecific = 999
}

export namespace InsuranceType {
  export function getDisplayName(value: number): string | null {
    switch (value) {
      case InsuranceType.Health:
        return 'Health';
      case InsuranceType.KidnapRansom:
        return 'Kidnap & Ransom';
      case InsuranceType.Life:
        return 'Life';
      case InsuranceType.CriticalIllness:
        return 'Critical Illness';
      case InsuranceType.Travel:
        return 'Travel';
      case InsuranceType.Telemedicine:
        return 'Telemedicine';
      case InsuranceType.Student:
        return 'Student';
      case InsuranceType.ICAonlyCasespecific:
        return 'ICA Case Specific';
      case InsuranceType.ICAonlyGeneralAgreement_notproductspecific:
        return 'ICA General Agreement';
      default:
        return null;
    }
  }
}
